import PayRatesSettings from './PayRatesSettings'

const financeSettingsPadding = { padding: '0 24px' as const }

const FinanceSettings = () => {
  return (
    <div style={financeSettingsPadding}>
      <PayRatesSettings />
    </div>
  )
}

export default FinanceSettings
